import React from 'react'
import LineChartLayout from '../layouts/LineChartLayout'
import PieChartLayout from '../layouts/PieChartLayout'
import BarChartLayout from '../layouts/BarChartLayout'
import VerticalBarChartLayout from '../layouts/VerticalBarChartLayout'
import NumberHorizontalLayout from '../layouts/NumberHorizontalLayout'
import classnames from 'classnames'

export default function selectFormat(metric, index, props) {
  let hasLeftMargin = index % 2 != 0
  switch(metric.format){
    case "bar_graph":
      return ( 
        <div className={classnames("col-12", "col-lg-6", "pl-0", { "pl-lg-3": true })} key={index}>
          <div className='bg-reg shadow mt-5'>
            <BarChartLayout {...props} metric={metric} dataKey={metric.dataKey} index={index} hasLeftMargin={hasLeftMargin}/> 
          </div>
        </div>
      )
      break
    case "vertical_bar_graph":
      return ( 
        <div className={classnames("col-12", "pl-0", { "pl-lg-3": true })} key={index}>
          <div className='bg-reg shadow mt-5'>
            <VerticalBarChartLayout {...props} metric={metric} dataKey={metric.dataKey} index={index} hasLeftMargin={hasLeftMargin}/> 
          </div>
        </div>
      )
      break
    case "line_graph":
      return ( 
        <div className={classnames("col-12", "pl-0", { "pl-lg-3": true })} key={index}>
          <div className='bg-reg shadow mt-5'>
            <LineChartLayout {...props} metric={metric} dataKey={metric.dataKey} index={index} hasLeftMargin={hasLeftMargin}/> 
          </div>
        </div>
      )
      break
    case "pie_chart":
      return ( 
        <div className={classnames("col-12", "col-lg-6", "pl-0", { "pl-lg-3": true })} key={index}>
          <div className='bg-reg mt-5'>
            <PieChartLayout {...props} metric={metric} index={index} hasLeftMargin={hasLeftMargin}/> 
          </div>
        </div>
      )
      break
    case "pie_chart_large":
      return ( 
        <div className={classnames("col-12", "col-lg-12", "pl-0", { "pl-lg-3": true })} key={index}>
          <div className='bg-reg mt-5'>
            <PieChartLayout {...props} metric={metric} index={index} hasLeftMargin={hasLeftMargin}/> 
          </div>
        </div>
      )
      break
    case "number_horizontal":
      return ( 
        <div className={classnames("col-12", "col-lg-6", "pl-0", { "pl-lg-3": true })} key={index}>
          <div className='bg-reg shadow mt-5'>
            <NumberHorizontalLayout {...props} metric={metric} index={index} hasLeftMargin={hasLeftMargin}/> 
          </div>
        </div>
      )
      break
    case "number_horizontal_full":
      return ( 
        <div className={classnames("col-12", "col-lg-12", "pl-0", { "pl-lg-3": true })} key={index}>
          <div className='bg-reg shadow mt-5'>
            <NumberHorizontalLayout {...props} metric={metric} index={index} hasLeftMargin={hasLeftMargin}/> 
          </div>
        </div>
      )
      break
    case "number_horizontal_large":
        return ( 
          <div className={classnames("col-12", "pl-0", { "pl-lg-3": true })} key={index}>
            <div className='bg-reg shadow mt-5'>
              <NumberHorizontalLayout {...props} metric={metric} index={index} hasLeftMargin={hasLeftMargin}/> 
            </div>
          </div>
        )
  }
}